import React, { useContext, useState } from "react";
import { LayoutContext } from "../../context/LayoutContext";
import CustomerWorkOrderListingHeader from "./CustomerWorkOrderListingHeader";
import CustomerWorkOrderTable from "./CustomerWorkOrderTable";

const CustomerWorkOrderList = () => {
  const { isBannerVisible } = useContext(LayoutContext);
  const [isGenerateInvoiceModalOpen, setIsGenerateInvoiceModalOpen] = useState(false);
  const [selectedWorkOrders, setSelectedWorkOrders] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState([]);

  return (
    <div
      className={`bg-[#F6F6F6] sm:fixed stikcy  2xl:w-[95.2%] xl:w-[93.2%] lg:w-[90.6%] md:w-[87.5%] sm:w-[95%] w-full h-screen transition-all ${
        isBannerVisible ? "top-[106px]" : "top-[56px]"
      }`}
    >
      <CustomerWorkOrderListingHeader
        selectedWorkOrders={selectedWorkOrders}
        setIsGenerateInvoiceModalOpen={setIsGenerateInvoiceModalOpen}
        selectedClient={selectedClient}
        status={selectedStatus}
        currency={selectedCurrency}
      />
      <CustomerWorkOrderTable
        setIsGenerateInvoiceModalOpen={setIsGenerateInvoiceModalOpen}
        isGenerateInvoiceModalOpen={isGenerateInvoiceModalOpen}
        setSelectedWorkOrders={setSelectedWorkOrders}
        selectedWorkOrders={selectedWorkOrders}
        setSelectedClient={setSelectedClient}
        selectedClient={selectedClient}
        setSelectedStatus={setSelectedStatus}
        setSelectedCurrency={setSelectedCurrency}
        selectedCurrency={selectedCurrency}
      />
    </div>
  );
};

export default CustomerWorkOrderList;
